import React from 'react';
import { motion } from 'framer-motion';
export function ReservationForm() {
  return <section id="reservas" className="py-20 md:py-32 bg-brand-primary" data-id="element-256">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-257">
        <div className="text-center mb-12" data-id="element-258">
          <h2 className="text-3xl md:text-5xl font-serif text-brand-cream mb-4" data-id="element-259">
            Haz tu Reserva
          </h2>
          <p className="text-brand-cream/70 text-lg mb-6" data-id="element-260">
            Garantiza tu mesa en la sede que prefieras
          </p>
          <div className="w-24 h-1 bg-brand-gold mx-auto" data-id="element-261"></div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-brand-secondary p-8 md:p-12 rounded-3xl border border-brand-gold/20" data-id="element-262">
          <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-263">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-264">
              <div data-id="element-265">
                <label className="block text-sm font-medium text-brand-cream/80 mb-2" data-id="element-266">
                  Nombre completo
                </label>
                <input type="text" className="w-full bg-brand-primary border border-brand-gold/30 rounded-xl px-4 py-3 text-brand-cream focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" placeholder="Ej. Juan Pérez" data-id="element-267" />
              </div>
              <div data-id="element-268">
                <label className="block text-sm font-medium text-brand-cream/80 mb-2" data-id="element-269">
                  Teléfono / WhatsApp
                </label>
                <input type="tel" className="w-full bg-brand-primary border border-brand-gold/30 rounded-xl px-4 py-3 text-brand-cream focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" placeholder="+57 300 000 0000" data-id="element-270" />
              </div>
              <div className="md:col-span-2" data-id="element-271">
                <label className="block text-sm font-medium text-brand-cream/80 mb-2" data-id="element-272">
                  Correo electrónico
                </label>
                <input type="email" className="w-full bg-brand-primary border border-brand-gold/30 rounded-xl px-4 py-3 text-brand-cream focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" placeholder="tucorreo@ejemplo.com" data-id="element-273" />
              </div>
              <div data-id="element-274">
                <label className="block text-sm font-medium text-brand-cream/80 mb-2" data-id="element-275">
                  Sede
                </label>
                <select className="w-full bg-brand-primary border border-brand-gold/30 rounded-xl px-4 py-3 text-brand-cream focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors appearance-none" data-id="element-276">
                  <option value="" data-id="element-277">Selecciona una sede</option>
                  <option value="zona-t" data-id="element-278">Zona T</option>
                  <option value="unicentro" data-id="element-279">Unicentro</option>
                  <option value="fontanar" data-id="element-280">Fontanar</option>
                  <option value="colina" data-id="element-281">La Colina</option>
                  <option value="salitre" data-id="element-282">Salitre</option>
                </select>
              </div>
              <div data-id="element-283">
                <label className="block text-sm font-medium text-brand-cream/80 mb-2" data-id="element-284">
                  Número de personas
                </label>
                <input type="number" min="1" className="w-full bg-brand-primary border border-brand-gold/30 rounded-xl px-4 py-3 text-brand-cream focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" placeholder="2" data-id="element-285" />
              </div>
              <div data-id="element-286">
                <label className="block text-sm font-medium text-brand-cream/80 mb-2" data-id="element-287">
                  Fecha de reserva
                </label>
                <input type="date" className="w-full bg-brand-primary border border-brand-gold/30 rounded-xl px-4 py-3 text-brand-cream focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" data-id="element-288" />
              </div>
              <div data-id="element-289">
                <label className="block text-sm font-medium text-brand-cream/80 mb-2" data-id="element-290">
                  Hora preferida
                </label>
                <input type="time" className="w-full bg-brand-primary border border-brand-gold/30 rounded-xl px-4 py-3 text-brand-cream focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" data-id="element-291" />
              </div>
              <div className="md:col-span-2" data-id="element-292">
                <label className="block text-sm font-medium text-brand-cream/80 mb-2" data-id="element-293">
                  Ocasión especial
                </label>
                <select className="w-full bg-brand-primary border border-brand-gold/30 rounded-xl px-4 py-3 text-brand-cream focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors appearance-none" data-id="element-294">
                  <option value="ninguna" data-id="element-295">Sin ocasión especial</option>
                  <option value="cumpleanos" data-id="element-296">Cumpleaños</option>
                  <option value="aniversario" data-id="element-297">Aniversario</option>
                  <option value="negocios" data-id="element-298">Reunión de negocios</option>
                </select>
              </div>
              <div className="md:col-span-2" data-id="element-299">
                <label className="block text-sm font-medium text-brand-cream/80 mb-2" data-id="element-300">
                  Mensaje adicional (opcional)
                </label>
                <textarea rows={4} className="w-full bg-brand-primary border border-brand-gold/30 rounded-xl px-4 py-3 text-brand-cream focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors resize-none" placeholder="Alergias, requerimientos especiales, etc." data-id="element-301"></textarea>
              </div>
            </div>

            <button type="submit" className="w-full bg-brand-gold text-brand-primary py-4 rounded-full font-bold text-lg hover:bg-yellow-500 transition-colors mt-8" data-id="element-302">
              CONFIRMAR RESERVA
            </button>
          </form>

          <div className="mt-8 text-center" data-id="element-303">
            <a href="https://wa.me/573508108717" target="_blank" rel="noreferrer" className="inline-flex items-center text-brand-cream/70 hover:text-[#25D366] transition-colors" data-id="element-304">
              ¿Prefieres escribirnos directo? Reserva por WhatsApp
              <svg className="w-5 h-5 ml-2" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-305">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" data-id="element-306" />
              </svg>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}